import type { UseFormReturn } from "react-hook-form";

export enum OrgchartType {
  Employees = "employees-organization-structure",
  Areas = "areas-organization-structure",
}

export interface IEmployeeAutocomplete {
  id: string;
  label: string;
  initials: string;
  position?: string;
  avatar?: string;
  name?: string;
}

interface IAreaAutoComplete {
  areaId: string;
  name: string;
}

export interface IOrgchartViewQueryParams {
  autocomplete: IEmployeeAutocomplete | IAreaAutoComplete | "" | null;
  orgChartType: OrgchartType;
}

export interface IFilterBar {
  companyId: string;
  updateQueryParameters: (params: IOrgchartViewQueryParams) => void;
  methods: UseFormReturn<IOrgchartViewQueryParams>;
}
